import { useState, useCallback } from "react";
import { DEFAULT_LAYOUT_CONFIG } from "@cristream/shared";
const MAX_UNDO = 20;
export function useEditorState(initial) {
    const [state, setState] = useState({
        layout: initial ?? DEFAULT_LAYOUT_CONFIG,
        selectedId: null,
        undoStack: [],
        isDirty: false,
    });
    const pushUndo = useCallback((prev) => {
        setState((s) => ({
            ...s,
            undoStack: [...s.undoStack.slice(-MAX_UNDO + 1), prev],
        }));
    }, []);
    const updateElement = useCallback((id, patch) => {
        setState((s) => {
            pushUndo(s.layout);
            return {
                ...s,
                isDirty: true,
                layout: {
                    ...s.layout,
                    elements: s.layout.elements.map((el) => el.id === id ? { ...el, ...patch } : el),
                },
            };
        });
    }, [pushUndo]);
    const updateCanvas = useCallback((patch) => {
        setState((s) => {
            pushUndo(s.layout);
            return {
                ...s,
                isDirty: true,
                layout: {
                    ...s.layout,
                    canvas: { ...s.layout.canvas, ...patch },
                },
            };
        });
    }, [pushUndo]);
    const setSelectedId = useCallback((id) => {
        setState((s) => ({ ...s, selectedId: id }));
    }, []);
    const undo = useCallback(() => {
        setState((s) => {
            if (s.undoStack.length === 0)
                return s;
            const prev = s.undoStack[s.undoStack.length - 1];
            return {
                ...s,
                layout: prev,
                undoStack: s.undoStack.slice(0, -1),
                isDirty: true,
            };
        });
    }, []);
    const resetToDefault = useCallback(() => {
        setState((s) => {
            pushUndo(s.layout);
            return {
                ...s,
                layout: DEFAULT_LAYOUT_CONFIG,
                isDirty: true,
                selectedId: null,
            };
        });
    }, [pushUndo]);
    const setLayout = useCallback((layout) => {
        setState({
            layout,
            selectedId: null,
            undoStack: [],
            isDirty: false,
        });
    }, []);
    return {
        layout: state.layout,
        selectedId: state.selectedId,
        isDirty: state.isDirty,
        canUndo: state.undoStack.length > 0,
        updateElement,
        updateCanvas,
        setSelectedId,
        undo,
        resetToDefault,
        setLayout,
    };
}
